import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppText, Row, styled, useTheme } from '@streem/ui-react';
import { CallDetailKeyValueTile } from './call_detail_key_value_tile';
export const createAttributesFromCustomer = (customer, useDisplayAsPillCapabilityYn) => {
    const attributes = [];
    if (customer.planType) {
        attributes.push({
            key: 'Plan Type',
            value: customer.planType,
            widthPercentage: 30,
        });
    }
    if (customer.contractNumber) {
        attributes.push({
            key: 'Plan Number',
            value: customer.contractNumber,
            widthPercentage: 30,
            isCopyableYn: true,
            shouldMask: false,
        });
    }
    if (typeof customer.callsAvailable === 'number') {
        attributes.push({
            key: 'Calls Available',
            value: customer.callsAvailable.toString(),
            widthPercentage: 30,
            shouldMask: false,
        });
    }
    if (customer.address) {
        // address should be wider than the other columns
        attributes.push({
            key: 'Covered Property Address',
            value: customer.address,
            widthPercentage: 30,
            shouldMask: true,
        });
    }
    if (customer.hvacEligible != null) {
        attributes.push({
            key: 'HVAC Eligible',
            value: customer.hvacEligible ? 'Yes' : 'No',
            widthPercentage: 30,
            shouldMask: false,
            displayAsPillYn: useDisplayAsPillCapabilityYn,
            highlightedBackgroundYn: !!customer.hvacEligible,
        });
    }
    return attributes;
};
export const MemberInformation = ({ customer, widthPercentage = 100, columnsPerRow, style, dataIdPrefix, keyValueStyles, keyValueTileStyles, memberInformationStyles = {}, isTrayOpen, useDisplayAsPillCapabilityYn = false, }) => {
    const theme = useTheme();
    const effectiveTitleFontSize = (memberInformationStyles.titleFontSize ||
        theme.text.size.mediumLarge);
    const effectiveItemFontSize = (keyValueStyles?.fontSize || theme.text.size.medium);
    const customerAttributes = createAttributesFromCustomer(customer, useDisplayAsPillCapabilityYn);
    const attributesSection = customerAttributes.length > 0 ? (_jsx(CallDetailKeyValueTile, { keyValuePairs: customerAttributes, columnsPerRow: columnsPerRow, dataIdPrefix: dataIdPrefix, keyValueStyles: { fontSize: effectiveItemFontSize }, keyValueTileStyles: keyValueTileStyles, isTrayOpen: isTrayOpen })) : (_jsx(NoAttributesSection, { children: _jsx(AppText, { size: "notQuiteAllTheWayMediumLarge", headingFontFamily: true, "data-testid": `${dataIdPrefix}-no-member-information-available`, children: "No Member Information Available" }) }));
    return (_jsxs(MemberInformationWrapper, { widthPercentage: widthPercentage, style: style, children: [_jsx(HeaderWrapper, { titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-member-information-header`, headerBottomMargin: memberInformationStyles.headerBottomMargin ?? '0.5rem', children: "Member Information" }), attributesSection] }));
};
const MemberInformationWrapper = styled.section(props => ({
    display: 'inline-flex',
    flexDirection: 'column',
    width: props.widthPercentage ? `${props.widthPercentage}%` : undefined,
    ...props.style,
}));
const HeaderWrapper = styled.div(props => ({
    marginBottom: props.headerBottomMargin,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const NoAttributesSection = styled(Row)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.colors.grey01A50,
    padding: '2rem 0',
}));
//# sourceMappingURL=member_information.js.map